import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    project: null,
    projects: []
};

const slice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else {
                state.error = action.payload;
            }
        },
        getProjectSuccess(state, action) {
            state.project = action.payload;
        },
        getProjectsSuccess(state, action) {
            state.projects = action.payload.projectList;
        }
    }
});

export default slice.reducer;

export function getProject(data, callback) {
    return async () => {
        try {
            const response = await axios.get(`/api/project/info/${data}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.getProjectSuccess(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getProjects(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/project/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.getProjectsSuccess(response.data));
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function createProject(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/project/create', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateProject(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/project/update', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
